import type { ActiveHintStage } from "@/game/feedback";

import { defineCurriculumVoiceCue, type CurriculumVoiceCue } from "./cue";

const ENGLISH_CHOICE_FEEDBACK_CUES: Readonly<
  Record<ActiveHintStage, CurriculumVoiceCue>
> = {
  "gentle-hint": defineCurriculumVoiceCue(
    "/audio/english/feedback/choice-gentle-hint.ogg",
    "这个声音有点像呢。再听一次，让小耳朵帮你认出来。"
  ),
  "reduced-choices": defineCurriculumVoiceCue(
    "/audio/english/feedback/choice-reduced-choices.ogg",
    "只剩几个选项啦。听完，再慢慢看一看。"
  ),
  "replay-demonstration": defineCurriculumVoiceCue(
    "/audio/english/feedback/choice-replay-demonstration.ogg",
    "点点把示范再放一遍。听清以后，我们再选。"
  )
};

const ENGLISH_RHYTHM_FEEDBACK_CUES: Readonly<
  Record<ActiveHintStage, CurriculumVoiceCue>
> = {
  "gentle-hint": defineCurriculumVoiceCue(
    "/audio/english/feedback/rhythm-gentle-hint.ogg",
    "小节奏刚才拐了个弯。再听一遍，跟着词的顺序来。"
  ),
  "reduced-choices": defineCurriculumVoiceCue(
    "/audio/english/feedback/rhythm-reduced-choices.ogg",
    "亮起来的词在带路。跟着它们，一个一个点。"
  ),
  "replay-demonstration": defineCurriculumVoiceCue(
    "/audio/english/feedback/rhythm-replay-demonstration.ogg",
    "点点把整句再放一遍。听完，我们跟着节奏再来。"
  )
};

export function getEnglishChoiceFeedbackCue(
  stage: ActiveHintStage
): CurriculumVoiceCue {
  return ENGLISH_CHOICE_FEEDBACK_CUES[stage];
}

export function getEnglishRhythmFeedbackCue(
  stage: ActiveHintStage
): CurriculumVoiceCue {
  return ENGLISH_RHYTHM_FEEDBACK_CUES[stage];
}

export const ENGLISH_FEEDBACK_CUES = [
  ...Object.values(ENGLISH_CHOICE_FEEDBACK_CUES),
  ...Object.values(ENGLISH_RHYTHM_FEEDBACK_CUES)
] as const;
